import type { FC } from 'react'
import logo from '~/assets/images/svg/logo_1.svg'

export const Logo: FC = () =>
	<div className='my-10'>
		<img src={logo} alt='Icon' className='w-3/5 mx-auto' />
	</div>
